import { Directive, Input, OnInit } from '@angular/core';

import { BannerComponent } from 'app/ui-components/banner/banner.component';

import { BannerKeys } from '../model/banner-keys.enum';
import { BannerService } from '../service/banner.service';

@Directive({
  selector: '[ccBannerLogic]',
})
export class BannerLogicDirective implements OnInit {
  isVisible: boolean;

  @Input() bannerKey: BannerKeys;

  constructor(
    private readonly bannerComponent: BannerComponent,
    private readonly bannerService: BannerService,
  ) {}

  ngOnInit(): void {
    this.isVisible = this.bannerService.isVisible(this.bannerKey);
    this.bannerComponent.updateVisibilityByBannerLogicDirective(this.isVisible);
  }
}
